import moment from 'moment-timezone';
import _ from 'lodash';

import { fieldTypes } from '../constants/metainf';
import { extractMetaFor } from './filter';
import { splitPostfix } from '../constants/event';

export const emptyTableConfig = {
  rows: [],
  columns: [],
  pivotBy: [],
};

export const getFormatByColumn = (column) => {
  switch (column.toUpperCase()) {
    case 'HOUR':
      return 'YYYY-MM-DD HH:mm';
    case 'MINUTE':
      return 'YYYY-MM-DD HH:mm';
    case 'SECOND':
      return 'YYYY-MM-DD HH:mm:ss';
    default:
      return 'YYYY-MM-DD';
  }
};

const customAccessor = (metainf, column, value, zoneId) => {
  // если у названия колонки есть постфикс '.split', мы его удаляем, чтобы получить оригинальное название
  const splitPostfixLength = splitPostfix.length;
  const preparedColumn =
    column.slice(-splitPostfixLength) === splitPostfix
      ? column.slice(0, -splitPostfixLength)
      : column;
  const { type } = extractMetaFor(preparedColumn, metainf);
  if (value === 'Others') {
    return value;
  }

  switch (type) {
    case fieldTypes.DATE:
    case fieldTypes.TIME:
    case fieldTypes.COHORT:
      return moment.tz(Number(value), zoneId).format(getFormatByColumn(preparedColumn));
    default:
      return value;
  }
};

export const makeTableConfig = (
  metainf,
  { columns, rows },
  zoneId,
  isSplit = false,
  originalColumns = columns
) => {
  const prepareColumn = (column, index) => {
    const getAccessor = (d) => {
      switch (d[column]) {
        case undefined:
          return '—';
        case null:
          return 'null';
        case 'null':
          return 'null';
        case true:
          return 'true';
        case false:
          return 'false';
        default:
          return customAccessor(metainf, originalColumns[index], d[column], zoneId);
      }
    };

    return {
      Header: column,
      // имена колонок могут совпадать, но id должен быть уникален, поэтому id генерится таким способом.
      id: column + index,
      // accessor: d => _.isNil(d[column]) ? '—' : customAccessor(metainf, originalColumns[index], d[column], zoneId),
      accessor: getAccessor,
      aggregate: (items) => items.join(', '),
    };
  };

  const preparedColumns = columns.map(prepareColumn);

  return {
    rows,
    columns: preparedColumns,
    pivotBy: isSplit ? [`${columns[0]}0`] : [],
  };
};

export const isEmptyConfig = (executionEvent) => {
  const rows = _.get(executionEvent, 'result.rows', []);
  return _.isNil(executionEvent) || rows.length === 0;
};

export const getConfig = (executionEvent, metainf, zoneId, isSplit) => {
  if (isEmptyConfig(executionEvent)) {
    return emptyTableConfig;
  }
  const { columns, rows } = executionEvent.result;
  return makeTableConfig(
    metainf,
    { rows, columns },
    zoneId,
    isSplit && executionEvent.result.columns.length > 2
  );
};
